<template>
    <div>
        <h5>All {{ label('Tasks') }}</h5>
        <TaskCriteria />
        <TasksTable />
    </div>
</template>
<script setup>
import TaskCriteria from '../modules/TaskCriteria.vue';
import TasksTable from '../modules/TasksTable.vue';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();
</script>
